import { render, staticRenderFns } from "./UploadPayroll.vue?vue&type=template&id=e8772ff8&scoped=true"
import script from "./UploadPayroll.vue?vue&type=script&lang=js"
export * from "./UploadPayroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8772ff8",
  null
  
)

export default component.exports